const hasVal = (v) => v !== '' && v !== null && v !== undefined;

export function createLabelSpecification(type, data) {
  switch (type) {
    case 'nominal':
      const minOk = hasVal(data.specMin);
      const nomOk = hasVal(data.specNominal);
      const maxOk = hasVal(data.specMax);

      // min + nominal + max
      if (minOk && nomOk && maxOk)
        return `${data.specMin} - ${data.specNominal} - ${data.specMax}`;
      // tylko nominal
      if (!minOk && nomOk && !maxOk) return `${data.specNominal}`;

      // tylko max
      if (!minOk && !nomOk && maxOk) return `< ${data.specMax}`;

      // tylko min
      if (minOk && !nomOk && !maxOk) return `> ${data.specMin}`;

      // min + max
      if (minOk && !nomOk && maxOk) return `${data.specMin} - ${data.specMax}`;

      // inne kombinacje (np. min+nominal albo nominal+max) — możesz ustalić jak chcesz
      if (minOk && nomOk && !maxOk)
        return `${data.specMin} - ${data.specNominal}`;
      if (!minOk && nomOk && maxOk)
        return `${data.specNominal} - ${data.specMax}`;
    case 'minB':
      const minOK = hasVal(data.minBMin);
      const maxOK = hasVal(data.minBMax);
      if (minOK && maxOK)
        return (data = {
          descriptionOrder: 'minB',
          label: 'Strefa B',
          min: parseFloat(data.minBMin),
          max: parseFloat(data.minBMax),
          rangeLabel: `${data.minBMin} - ${data.minBMax}`,
        });

      if (minOK && !maxOK)
        return (data = {
          label: 'Strefa B',
          descriptionOrder: 'minB',
          min: parseFloat(data.minBMin),
          max: null,
          rangeLabel: `> ${data.minBMin}`,
        });
      if (!minOK && maxOK)
        return (data = {
          label: 'Strefa B',
          descriptionOrder: 'minB',
          min: null,
          max: parseFloat(data.minBMax),
          rangeLabel: `< ${data.minBMax}`,
        });

    case 'minX':
      const minXOK = hasVal(data.minXMin);
      const maxXOK = hasVal(data.minXMax);
      if (minXOK && maxXOK)
        return (data = {
          descriptionOrder: 'minX',
          label: 'Strefa X',
          min: parseFloat(data.minXMin),
          max: parseFloat(data.minXMax),
          rangeLabel: `${data.minXMin} - ${data.minXMax}`,
        });
      if (minXOK && !maxXOK)
        return (data = {
          label: 'Strefa X',
          descriptionOrder: 'minX',
          min: parseFloat(data.minXMin),
          max: null,
          rangeLabel: `> ${data.minXMin}`,
        });
      if (!minXOK && maxXOK)
        return (data = {
          label: 'Strefa X',
          descriptionOrder: 'minX',
          min: null,
          max: parseFloat(data.minXMax),
          rangeLabel: `< ${data.minXMax}`,
        });
    case 'maxX':
      const maxXMinOK = hasVal(data.maxXMin);
      const maxXMaxOK = hasVal(data.maxXMax);
      if (maxXMinOK && maxXMaxOK)
        return (data = {
          descriptionOrder: 'maxX',
          label: 'Strefa X',
          min: parseFloat(data.maxXMin),
          max: parseFloat(data.maxXMax),
          rangeLabel: `${data.maxXMin} - ${data.maxXMax}`,
        });
      if (maxXMinOK && !maxXMaxOK)
        return (data = {
          label: 'Strefa X',
          descriptionOrder: 'maxX',
          min: parseFloat(data.maxXMin),
          max: null,
          rangeLabel: `> ${data.maxXMin}`,
        });
      if (!maxXMinOK && maxXMaxOK)
        return (data = {
          label: 'Strefa X',
          descriptionOrder: 'maxX',
          min: null,
          max: parseFloat(data.maxXMax),
          rangeLabel: `< ${data.maxXMax}`,
        });
    case 'maxB':
      const maxBminOK = hasVal(data.maxBMin);
      const maxBMaxOK = hasVal(data.maxBMax);
      if (maxBminOK && maxBMaxOK)
        return (data = {
          descriptionOrder: 'maxB',
          label: 'Strefa B',
          min: parseFloat(data.maxBMin),
          max: parseFloat(data.maxBMax),
          rangeLabel: `${data.maxBMin} - ${data.maxBMax}`,
        });
      if (maxBminOK && !maxBMaxOK)
        return (data = {
          label: 'Strefa B',
          descriptionOrder: 'maxB',
          min: parseFloat(data.maxBMin),
          max: null,
          rangeLabel: `> ${data.maxBMin}`,
        });
      if (!maxBminOK && maxBMaxOK)
        return (data = {
          label: 'Strefa B',
          descriptionOrder: 'maxB',
          min: null,
          max: parseFloat(data.maxBMax),
          rangeLabel: `< ${data.maxBMax}`,
        });
    default:
      return null;
  }
}
